import Component_Html_250150b9af4d54a714ad0b25076740a1 from "../../../../content/examples/gui/html/Html";
import Devtool_Html_250150b9af4d54a714ad0b25076740a1 from "!!@devtool/loader!../../../../content/examples/gui/html/Html";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Html_250150b9af4d54a714ad0b25076740a1,
  Devtool_Html_250150b9af4d54a714ad0b25076740a1,
  DevTool,
  React
};